<template>
  <v-card class="rounded-lg pa-2 white" flat>
    <v-card-title class="secondary--text" style="font-size: medium; margin-top: -10px">
      خرید و فروش خالص ماهانه
      <v-spacer></v-spacer>
    <chart-export-btn page-chart-id="buy-sell-chart"></chart-export-btn>
    </v-card-title>
    <canvas  height="110" id="buy-sell-chart"></canvas>
  </v-card>
</template>
<script>
import Chart from 'chart.js'
import ChartExportBtn from "@/components/scomponents/ChartExportBtns";

export default {
  name: 'BuyAndSellChart',
  components: {ChartExportBtn},
  data() {
    return {
      sums: null,
      chartData: {
        type: "line",
        data: {
          labels: [],
          datasets: [
            {
              label: "فروش",
              data: [],
              borderColor: "#3d587f",
              backgroundColor: "rgba(241, 65, 108, .08)",
              borderWidth: 3,
              hoverBorderWidth: 5,

            },
            {
              label: "خرید",
              data: [],
              borderWidth: 3,
              hoverBorderWidth: 5,
              backgroundColor: "rgba(255, 135, 0,.08)",
              borderColor: "#FF8700",
            }
          ]
        },

        options: {
          title: {
            display: true,
            text: '',
            fontColor: "#000",
            fontSize: 18,
          },
          responsive: true,
          legend: {
            display: false,
            labels: {
              fontColor: "#000",
            }
          },
          interaction: {
            intersect: true,
            mode: 'index',
          },
          tooltips: {
            enabled: true,
            mode: 'index',
            position: 'average',
            callbacks: {
              label: function (tooltipItem, data) {
                let label = data.datasets[tooltipItem.datasetIndex].label || ''
                if (label) {
                  label += ' : '
                }
                if(parseInt(tooltipItem.yLabel) >= 1000){
                  label += tooltipItem.yLabel.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") + ' ريال ';
                } else {
                  label += tooltipItem.yLabel + ' ريال ';
                }
                return label
              },
            },
          },
          scales: {
            xAxes: [{
              gridLines: {
                display: false,
              },
              ticks: {
                fontColor: "#000",
              }
            }],
            yAxes: [
              {
                gridLines: {
                  color: "rgba(161, 161, 161, .12)",
                },
                ticks: {
                  fontColor: "#000",
                  beginAtZero: true,
                  padding: 15,
                  callback: function(value, index, values) {
                    if(parseInt(value) >= 1000){
                      return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") + ' ريال ';
                    } else {
                      return value + ' ريال ';
                    }
                  }
                },
              }
            ]
          }
        }
      },

    }
  },

  mounted() {
    this.request({
      url: this.endpoint(`reports/BuySaleChart`),
      method: "get",
      success: data => {
        this.sums = data.results
        console.log(this.sums)
        this.getData()
      }
    })
  },
  methods: {
    getData() {
      this.chartData.options.title.text = 'شرکت ' + this.company.name + '  سال مالی ' + this.financialYear.name
      this.chartData.options.title.fontSize =  15
      this.chartData.data.labels = []
      for (let month of this.sums.buy){
        this.chartData.data.labels.push(month.label)
      }
      for (let month of this.sums.sale){
        this.chartData.data.datasets[0].data.push(month.sum.amount)
      }
      for (let month of this.sums.buy){
        this.chartData.data.datasets[1].data.push(month.sum.amount)
      }
      this.getChart()
    },
    getChart(){
      const ctx = document.getElementById('buy-sell-chart');
      new Chart(ctx, this.chartData);
    }
  },
}
</script>